export default {
    path: "/operator",
    component: () => import("@/layouts/main.vue"),
    redirect: {name: "rumah"},
    meta: {
        authRequired: true,
        verificationRequired: true,
        roles : ["administrator", "operator_kabupaten"]
    },
    children: [
        {
            path: "rumah",
            name: "rumah",
            meta: {
                title: "Rumah",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/rumah/index.vue"),
        },
        {
            path: "rumah/:id/update",
            name: "rumah-update",
            meta: {
                title: "Perbarui Rumah",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/rumah/update.vue"),
        },
        {
            path: "unggah-cpb",
            name: "unggah-cpb",
            meta: {
                title: "Unggah Dokumen CPB",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/unggah-data-rumah/cpb.vue"),
        },
        {
            path: "unggah-periksa-kualitas",
            name: "unggah-periksa-kualitas",
            meta: {
                title: "Unggah Dokumen Periksa Kualitas",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/unggah-data-rumah/periksa-kualitas.vue"),
        },
        {
            path: "rumah-create",
            name: "rumah-create",
            meta: {
                title: "Tambah Rumah Baru",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/rumah/create.vue"),
        },
        {
            path: "rumah-dokumen/:id",
            name: "rumah-dokumen",
            meta: {
                title: "Rumah Dokumen",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/rumah/dokumen.vue"),
        },
        {
            path: "pengukuran/:id/",
            name: "pengukuran-detail",
            meta: {
                title: "Detail Pengukuran",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/rumah/pengukuran.vue"),
        },
        {
            path: "pengukuran-create/:id",
            name: "pengukuran-create",
            meta: {
                title: "Tambah Pengukuran Baru",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/rumah/createPengukuran.vue"),
        },
        {
            path: "riwayat-pengukuran",
            name: "riwayat-pengukuran",
            meta: {
                title: "Perbarui Riwayat Pengukuran",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/riwayat-pengukuran/index.vue"),
        },
        {
            path: "riwayat-pengukuran/create",
            name: "riwayat-pengukuran-create",
            meta: {
                title: "Tambah Riwayat Pengukuran",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/riwayat-pengukuran/create.vue"),
        },
        {
            path: "riwayat-pengukuran/:id/update",
            name: "riwayat-pengukuran-update",
            meta: {
                title: "Perbarui Riwayat Pengukuran",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/riwayat-pengukuran/update.vue"),
        },
        {
            path: "riwayat-pengukuran-dokumen/:id",
            name: "riwayat-pengukuran-dokumen",
            meta: {
                title: "Riwayat Pengukuran Dokumen",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/riwayat-pengukuran/dokumen.vue"),
        },
        {
            path: "peta",
            name: "peta-titik-rumah",
            meta: {
                title: "Peta",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/peta/titik-rumah/index.vue"),
        },
        {
            path: "statistik-cpb",
            name: "statistik-cpb",
            meta: {
                title: "Statistik CPB Pasca Validasi",
                authRequired: true,
            },
            component: () => import("../views/custom/operator/statistik-cpb/index.vue"),
        },
    ],
};
